import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from './aws-exports'
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import { environment } from './config';

if (environment === 'prod') {
  Sentry.init({
    dsn: 'https://3a3e2d31b3214df7a6a0fc3a5ebb01c7@sentry.io/1542187',
    integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })],
  });
}

Amplify.configure({ ...awsconfig, ...{ Analytics: { disabled: true }}});

Vue.use(AmplifyPlugin, AmplifyModules)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
